import { useRouter } from "next/router"

export function useTableIdFromUrl() {
  const router = useRouter()
  const tableId = (router.query.tableId || router.query.tableid) as string | undefined
  return tableId
}
